import {type ParentDocumentFromRest, type ParentDocumentForApollo} from './parent-document';

export const parentDocumentTypePatcher = (data: ParentDocumentFromRest): ParentDocumentForApollo => {
    return {
        __typename: 'ParentDocument',
        ...data,
        documentId: data.permissionId,
    };
};
